import { Box } from '@chakra-ui/react'
import { DefaultMapPin } from 'components/map'

import { useRef, useEffect } from 'react'

export default function StaticPointerInTheCenter() {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!ref.current) return

    const rect = ref.current.getBoundingClientRect()
    console.log('altura do pin:', rect.height)
  }, [])

  return (
    <Box
      ref={ref}
      position="absolute"
      top="50%"
      left="50%"
      transform="translate(-50%, -100%)"
      zIndex="10"
      pointerEvents="none"
    >
      <DefaultMapPin />
    </Box>
  )
}
